import React from 'react';
import styled from '@emotion/styled';
import { Modal } from '../Modal/index';
import { BreakpointsEnum } from '../../helpers/breakpoints';
import { config } from '../../config';
import { Button } from '../Button/Button';
import { __ } from '../../helpers/TranslationService';
import { CrossIcon } from '../Icons/CrossIcon';

interface Props {
    className?: string;
    enableCatalogueSignUp: boolean;
    onBannerCloseHandler: () => void;
}

const StyledDialog = styled(Modal)`
    .modal__dialog {
        margin: 0;
        width: 100%;
        max-width: 100%;
        top: 100%;
        transform: translateY(-100%);
        border-radius: 16px 16px 0 0;
        overflow: hidden;

        @media (min-width: ${BreakpointsEnum.sm}) {
            border-radius: 16px;
        }
    }

    .modal__header {
        border-bottom: 1px solid ${(props) => props.theme.border.onBg};
    }

    .modal__body {
        display: flex;
        flex-direction: column;
    }

    .modal__title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
    }

    .icon-cross {
        font-size: 16px !important;
    }

    .modal__close-btn {
        padding: 15px;
    }

    .body-close-button {
        display: none;
    }

    @media (min-width: ${BreakpointsEnum.sm}) {
        .modal__header {
            display: none;
        }

        .modal__dialog {
            max-width: 450px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .modal__body {
            padding: 36px;
        }
    }
`;

const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;

    *:last-child {
        margin-left: auto;
    }

    button {
        display: none;
    }

    @media (min-width: ${BreakpointsEnum.sm}) {
        button {
            display: inline-flex;
        }
    }
`;

const HeaderTitle = styled.p`
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    margin: 0;
`;

const Body = styled.div`
    display: flex;
    flex-direction: column;

    p {
        font-size: 14px;
        line-height: 22px;
        margin: 0;
    }

    *:last-child {
        margin-top: 16px;
    }
`;

export const NewsletterModalSuccess = ({
    className,
    enableCatalogueSignUp,
    onBannerCloseHandler,
}: Props) => {
    return (
        <StyledDialog
            disableOverlayClose
            className={className}
            title={__('newsletter.headline', 'dreamlines')}
        >
            <Header>
                <HeaderTitle>
                    {enableCatalogueSignUp
                        ? __('wantToGetCatalog', 'dreamlines')
                        : __('Thank you! Your registration was successful!', 'dreamlines')}
                </HeaderTitle>

                <Button
                    paddings={false}
                    rounded={false}
                    color="flatSecondary"
                    size="small"
                    onClick={onBannerCloseHandler}
                >
                    <CrossIcon
                        style={{
                            width: '16px',
                            height: '16px',
                        }}
                    />
                </Button>
            </Header>
            <Body>
                <p>
                    {__(
                        'you are just one step away from getting all top offers: Please go to your E-Mail provider and verify your E-Mail address.',
                        'dreamlines',
                    )}
                </p>

                {enableCatalogueSignUp ? (
                    <Button as={'a'} href={__('brochureLink', 'dreamlines')} fullWidth>
                        {__('SignUpForFree', 'dreamlines')}
                    </Button>
                ) : (
                    <Button fullWidth size="large" color="primary" onClick={onBannerCloseHandler}>
                        {__('Close', 'dreamlines')}
                    </Button>
                )}
            </Body>
        </StyledDialog>
    );
};
